/**
 * Esquema del libro V4: cabeceras y fórmulas. Generado una vez a partir de apps/shared/WorkbookV4.js;
 * desde ahora es la fuente en TypeScript (un test comprueba que ambos coinciden mientras exista Apps Script).
 */
export const WORKBOOK_VERSION = 1;

/** Cabecera (fila 1) de cada pestaña con tabla. */
export const HEADERS = {
  "Notas": [
    "Mes",
    "Categoría",
    "Nota"
  ],
  "Categorías": [
    "Categoría",
    "Tipo",
    "Naturaleza",
    "Palabras clave (separadas por comas)"
  ],
  "Cuentas": [
    "Cuenta",
    "Banco",
    "Tipo",
    "Propiedad",
    "En patrimonio",
    "Saldo inicial",
    "Fecha saldo inicial",
    "Archivado",
    "Saldo calculado",
    "Saldo del banco",
    "Fecha saldo banco",
    "Diferencia",
    "",
    "Liquidez (tu parte)"
  ],
  "Movimientos": [
    "Fecha",
    "Concepto",
    "Importe",
    "Cuenta",
    "Categoría",
    "Compartido",
    "Grupo",
    "Nota",
    "Mes (opcional)"
  ],
  "Divisiones": [
    "Id movimiento",
    "Categoría",
    "Importe",
    "Nota"
  ],
  "Presupuesto": [
    "Año",
    "Categoría",
    "Mensual",
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Ago",
    "Sep",
    "Oct",
    "Nov",
    "Dic",
    "Avisar",
    "Nota"
  ],
  "Patrimonio": [
    "Mes",
    "Liquidez",
    "Inversiones",
    "Total",
    "Origen"
  ],
  "Archivo": [
    "Fecha",
    "Concepto",
    "Importe",
    "Cuenta",
    "Categoría",
    "Compartido",
    "Grupo",
    "Nota",
    "Mes informe",
    "Tipo",
    "Atribuible",
    "Id"
  ],
  "Histórico": [
    "Año",
    "Categoría",
    "Tipo",
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Ago",
    "Sep",
    "Oct",
    "Nov",
    "Dic",
    "Total"
  ],
  "_Meta": [
    "Id",
    "Origen",
    "Referencia banco",
    "Fecha valor",
    "Saldo tras movimiento",
    "Tricount enviado",
    "Tricount importe",
    "Importado el"
  ],
  "_Reglas": [
    "Prioridad",
    "Cuenta",
    "Contiene",
    "Regex",
    "Importe exacto",
    "Dirección",
    "Categoría",
    "Activa"
  ],
  "_Alias": [
    "Cuenta",
    "Fecha",
    "Importe",
    "Concepto del banco",
    "Id"
  ]
} as const;

/** Fórmulas por celda ('Pestaña!A1'). Las de la fila 1 generan una columna calculada entera. */
export const FORMULAS: Record<string, string> = {
  "Cuentas!H1": "={\"Archivado\";MAP(A2:A;LAMBDA(a;IF(a=\"\";\"\";ROUND(SUMIFS(Archivo!C2:C;Archivo!D2:D;a);2))))}",
  "Cuentas!I1": "={\"Saldo calculado\";MAP(A2:A;F2:F;H2:H;LAMBDA(a;f;h;IF(a=\"\";\"\";ROUND(f+h+SUMIFS(Movimientos!C2:C;Movimientos!D2:D;a);2))))}",
  "Cuentas!L1": "={\"Diferencia\";MAP(A2:A;I2:I;J2:J;LAMBDA(a;i;j;IF(OR(a=\"\";j=\"\");\"\";ROUND(j-i;2))))}",
  "Cuentas!N2": "=SUM(MAP(A2:A;D2:D;E2:E;I2:I;LAMBDA(a;p;e;i;IF(a=\"\";0;IF(e;p*i;0)))))",
  "Movimientos!J1": "={\"Categoría efectiva\";LET(gk;FILTER(G2:G;C2:C<0;G2:G<>\"\";E2:E<>\"\");ge;FILTER(E2:E;C2:C<0;G2:G<>\"\";E2:E<>\"\");MAP(A2:A;E2:E;G2:G;LAMBDA(a;e;g;IF(a=\"\";\"\";IF(e<>\"\";e;IF(g=\"\";\"Sin categoría\";IFERROR(XLOOKUP(g;gk;ge);\"Sin categoría\")))))))}",
  "Movimientos!K1": "={\"Mes informe\";LET(gk;FILTER(G2:G;C2:C<0;G2:G<>\"\";E2:E<>\"\");gm;FILTER(ARRAYFORMULA(IF(I2:I<>\"\";I2:I;YEAR(A2:A)&\"-\"&IF(MONTH(A2:A)<10;\"0\";\"\")&MONTH(A2:A)));C2:C<0;G2:G<>\"\";E2:E<>\"\");MAP(A2:A;C2:C;G2:G;I2:I;LAMBDA(a;c;g;i;IF(a=\"\";\"\";IF(i<>\"\";i;IF(AND(c>0;g<>\"\");IFERROR(XLOOKUP(g;gk;gm);YEAR(a)&\"-\"&IF(MONTH(a)<10;\"0\";\"\")&MONTH(a));YEAR(a)&\"-\"&IF(MONTH(a)<10;\"0\";\"\")&MONTH(a)))))))}",
  "Movimientos!L1": "={\"Compartido efectivo\";LET(gk;FILTER(G2:G;C2:C<0;G2:G<>\"\";E2:E<>\"\");gf;FILTER(F2:F;C2:C<0;G2:G<>\"\";E2:E<>\"\");MAP(A2:A;C2:C;F2:F;G2:G;LAMBDA(a;c;f;g;IF(a=\"\";\"\";IF(AND(c>0;g<>\"\");IFERROR(XLOOKUP(g;gk;gf);f);f)))))}",
  "Movimientos!M1": "={\"Tipo\";MAP(A2:A;C2:C;J2:J;LAMBDA(a;c;j;IF(a=\"\";\"\";IFERROR(XLOOKUP(j;'Categorías'!A2:A;'Categorías'!B2:B);IF(c<0;\"Gasto\";\"Ingreso\")))))}",
  "Movimientos!N1": "={\"Atribuible\";MAP(A2:A;C2:C;L2:L;M2:M;LAMBDA(a;c;l;m;IF(a=\"\";\"\";IF(OR(m=\"Gasto\";m=\"Ingreso\");ROUND(c*IF(l;1/2;1);2);0))))}",
  "Movimientos!P1": "={\"Sugerida\";MAP(A2:A;B2:B;E2:E;G2:G;LAMBDA(a;b;e;g;IF(OR(a=\"\";e<>\"\";g<>\"\");\"\";IFERROR(INDEX(FILTER('Categorías'!A2:A;'Categorías'!D2:D<>\"\";REGEXMATCH(LOWER(b);SUBSTITUTE(SUBSTITUTE(LOWER('Categorías'!D2:D);\", \";\"|\");\",\";\"|\")));1);\"\"))))}",
  "Divisiones!E1": "={\"Fecha\";MAP(A2:A;LAMBDA(id;IF(id=\"\";\"\";IFERROR(XLOOKUP(id;Movimientos!O2:O;Movimientos!A2:A);\"¿Id?\"))))}",
  "Divisiones!F1": "={\"Concepto\";MAP(A2:A;LAMBDA(id;IF(id=\"\";\"\";IFERROR(XLOOKUP(id;Movimientos!O2:O;Movimientos!B2:B);\"¿Id?\"))))}",
  "Divisiones!G1": "={\"Mes informe\";MAP(A2:A;LAMBDA(id;IF(id=\"\";\"\";IFERROR(XLOOKUP(id;Movimientos!O2:O;Movimientos!K2:K);\"¿Id?\"))))}",
  "Divisiones!H1": "={\"Compartido\";MAP(A2:A;LAMBDA(id;IF(id=\"\";\"\";IFERROR(XLOOKUP(id;Movimientos!O2:O;Movimientos!L2:L);\"¿Id?\"))))}",
  "Divisiones!I1": "={\"Tipo\";MAP(A2:A;B2:B;C2:C;LAMBDA(id;b;c;IF(id=\"\";\"\";IFERROR(XLOOKUP(b;'Categorías'!A2:A;'Categorías'!B2:B);IF(c<0;\"Gasto\";\"Ingreso\")))))}",
  "Divisiones!J1": "={\"Atribuible\";MAP(A2:A;C2:C;H2:H;I2:I;LAMBDA(id;c;h;t;IF(id=\"\";\"\";IF(OR(t=\"Gasto\";t=\"Ingreso\");ROUND(c*IFERROR(IF(h;1/2;1);1);2);0))))}",
  "Divisiones!K1": "={\"¿Cuadra?\";MAP(A2:A;LAMBDA(id;IF(id=\"\";\"\";IFERROR(IF(ABS(SUMIF(A2:A;id;C2:C)-XLOOKUP(id;Movimientos!O2:O;Movimientos!C2:C))<1/200;\"✓\";\"≠ no suma el total\");\"¿Id?\"))))}",
  "Patrimonio!D1": "={\"Total\";MAP(A2:A;B2:B;C2:C;LAMBDA(a;b;c;IF(a=\"\";\"\";b+c)))}",
  "Inversiones!G1": "={\"Participaciones\";MAP(F2:F;LAMBDA(f;IF(f=\"\";\"\";SUMIFS(D2:D;B2:B;f))))}",
  "Inversiones!J1": "={\"Valor\";MAP(F2:F;G2:G;H2:H;LAMBDA(f;g;h;IF(OR(f=\"\";h=\"\");\"\";ROUND(g*h;2))))}",
  "Inversiones!K1": "={\"Aportado\";MAP(F2:F;LAMBDA(f;IF(f=\"\";\"\";SUMIFS(C2:C;B2:B;f))))}",
  "Inversiones!L1": "={\"Ganancia\";MAP(F2:F;J2:J;K2:K;LAMBDA(f;j;k;IF(OR(f=\"\";j=\"\");\"\";j-k)))}",
  "Inversiones!N2": "=SUM(J2:J)",
  "Inversiones!N4": "=SUM(C2:C)",
  "Buscar!A10": "=IF(AND(B3=\"\";B4=\"\";B5=\"\";B6=\"\";B7=\"\");\"Escribe algo arriba para buscar\";LET(d;VSTACK(CHOOSECOLS(Movimientos!A2:O;1;2;3;4;10;7;8);CHOOSECOLS(Archivo!A2:L;1;2;3;4;5;7;8));f;FILTER(d;(CHOOSECOLS(d;1)<>\"\")*((B3=\"\")+ISNUMBER(SEARCH(B3;CHOOSECOLS(d;2)&\" \"&CHOOSECOLS(d;7))))*((B4=\"\")+(CHOOSECOLS(d;1)>=B4))*((B5=\"\")+(CHOOSECOLS(d;1)<=B5))*((B6=\"\")+(CHOOSECOLS(d;5)=B6))*((B7=\"\")+(CHOOSECOLS(d;4)=B7)));IFERROR(SORT(f;1;0);\"Sin resultados\")))",
  "Resumen!B5": "=B3&\"-\"&IF(B4<10;\"0\";\"\")&B4",
  "Resumen!D4": "=SUMIFS(Movimientos!N2:N;Movimientos!K2:K;$B$5;Movimientos!M2:M;\"Ingreso\")+SUMIFS(Divisiones!J2:J;Divisiones!G2:G;$B$5;Divisiones!I2:I;\"Ingreso\")",
  "Resumen!E4": "=SUMIFS(Movimientos!N2:N;Movimientos!K2:K;$B$5;Movimientos!M2:M;\"Gasto\")+SUMIFS(Divisiones!J2:J;Divisiones!G2:G;$B$5;Divisiones!I2:I;\"Gasto\")",
  "Resumen!F4": "=D4+E4",
  "Resumen!G4": "=IF(D4>0;F4/D4;\"\")",
  "Resumen!H4": "=Cuentas!N2+'Inversiones'!N2",
  "Resumen!A9": "=FILTER('Categorías'!A2:A;'Categorías'!B2:B=\"Gasto\")",
  "Resumen!B9": "=MAP(FILTER('Categorías'!A2:A;'Categorías'!B2:B=\"Gasto\");LAMBDA(c;LET(r;FILTER(Presupuesto!C2:O;Presupuesto!A2:A=$B$3;Presupuesto!B2:B=c);IFERROR(IF(INDEX(r;1;$B$4+1)<>\"\";INDEX(r;1;$B$4+1);INDEX(r;1;1));\"\"))))",
  "Resumen!C9": "=MAP(FILTER('Categorías'!A2:A;'Categorías'!B2:B=\"Gasto\");LAMBDA(c;-(SUMIFS(Movimientos!N2:N;Movimientos!J2:J;c;Movimientos!K2:K;$B$5)+SUMIFS(Divisiones!J2:J;Divisiones!B2:B;c;Divisiones!G2:G;$B$5))))",
  "Resumen!D9": "=ARRAYFORMULA(IF((A9:A80=\"\")+(B9:B80=\"\");\"\";B9:B80-C9:C80))",
  "Resumen!E9": "=ARRAYFORMULA(IF((A9:A80=\"\")+(B9:B80=\"\");\"\";IF(B9:B80=0;IF(C9:C80>0;999/100;0);C9:C80/B9:B80)))",
  "Resumen!F9": "=ARRAYFORMULA(IF(E9:E80=\"\";\"\";IF(E9:E80>1;\"⚠ pasado\";IF(E9:E80>=9/10;\"casi\";\"\"))))",
  "Resumen!I9": "=MAKEARRAY(1;12;LAMBDA(r;m;SUMIFS(Movimientos!N2:N;Movimientos!K2:K;$B$3&\"-\"&IF(m<10;\"0\";\"\")&m)+SUMIFS(Divisiones!J2:J;Divisiones!G2:G;$B$3&\"-\"&IF(m<10;\"0\";\"\")&m)))",
  "Resumen!U9": "=SUM(I9:T9)",
  "Resumen!H10": "=VSTACK(FILTER('Categorías'!A2:A;'Categorías'!B2:B=\"Ingreso\");FILTER('Categorías'!A2:A;'Categorías'!B2:B=\"Gasto\");\"Sin categoría\")",
  "Resumen!I10": "=LET(c;VSTACK(FILTER('Categorías'!A2:A;'Categorías'!B2:B=\"Ingreso\");FILTER('Categorías'!A2:A;'Categorías'!B2:B=\"Gasto\");\"Sin categoría\");MAKEARRAY(ROWS(c);12;LAMBDA(r;m;SUMIFS(Movimientos!N2:N;Movimientos!J2:J;INDEX(c;r);Movimientos!K2:K;$B$3&\"-\"&IF(m<10;\"0\";\"\")&m)+SUMIFS(Divisiones!J2:J;Divisiones!B2:B;INDEX(c;r);Divisiones!G2:G;$B$3&\"-\"&IF(m<10;\"0\";\"\")&m))))",
  "Resumen!U10": "=BYROW(I10:T80;LAMBDA(r;IF(COUNT(r)=0;\"\";SUM(r))))",
  "_Control!B3": "=COUNTA(Archivo!A2:A)&\"|\"&ROUND(SUM(Archivo!C2:C);2)&\"|\"&SUMPRODUCT(ROW(Archivo!A2:A)*Archivo!A2:A)&\"|\"&ROUND(SUMPRODUCT(ROW(Archivo!C2:C)*Archivo!C2:C);2)&\"|\"&SUMPRODUCT(ROW(Archivo!E2:E)*IFERROR(MATCH(Archivo!E2:E;'Categorías'!A2:A;0);0))&\"|\"&SUMPRODUCT(ROW(Archivo!D2:D)*IFERROR(MATCH(Archivo!D2:D;Cuentas!A2:A;0);0))&\"|\"&SUMPRODUCT(ROW(Archivo!B2:B)*LEN(Archivo!B2:B&Archivo!G2:G&Archivo!H2:H))",
  "_Control!B10": "=SORT(UNIQUE(FILTER(VALUE(LEFT(Movimientos!K2:K;4));Movimientos!K2:K<>\"\")))",
};

/** Ajustes de saldo: un movimiento en una categoría que no cuenta, marcado en _Meta con este origen. */
export const ADJUSTMENT_SOURCE = 'ajuste';
export const ADJUSTMENT_CATEGORY = 'Ajuste de saldo';

/** Pestaña oculta «_Pedidos» (se crea al guardar el primer pedido de Amazon): una fila por artículo de cada pedido, envío o reembolso. */
export const ORDERS_TAB = '_Pedidos';
export const ORDERS_HEADERS = ['Fecha', 'Tipo', 'Pedido', 'Artículo', 'Cantidad', 'Importe', 'Total', 'Ref', 'Movimiento'];

/** Pestaña «Previstos» (se crea al guardar el primer gasto previsto). */
export const PLANNED_HEADERS = ['Id', 'Categoría', 'Mes', 'Importe', 'Concepto', 'Palabra', 'Repetir', 'Desde', 'Hasta', 'Presupuesto', 'Vinculados', 'Desvinculados'];
